"use client";

import { c as _c } from "react/compiler-runtime";
import { DollarSign, TrendingUp, Coins } from "lucide-react";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { MetricCard } from "@/components/dashboard/metric-card";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/lib/components/card";
import { mockCostBreakdown, mockMetrics } from "@/lib/mock-feature-data";
const COLORS = ["#4f46e5", "#0ea5e9", "#10b981", "#f59e0b"];
function PieTooltipContent(t0) {
  const $ = _c(9);
  const {
    payload
  } = t0;
  if (payload && payload.length) {
    let t1;
    if ($[0] !== payload[0].name) {
      t1 = <p className="font-medium">{payload[0].name}</p>;
      $[0] = payload[0].name;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    const t2 = Number(payload[0].value);
    let t3;
    if ($[2] !== t2) {
      t3 = t2.toFixed(2);
      $[2] = t2;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== t3) {
      t4 = <p className="text-sm">${t3}</p>;
      $[4] = t3;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== t1 || $[7] !== t4) {
      t5 = <div className="rounded-lg border bg-popover text-popover-foreground p-2 shadow-sm">{t1}{t4}</div>;
      $[6] = t1;
      $[7] = t4;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    return t5;
  }
  return null;
}
export function CostAnalyticsDemo() {
  const $ = _c(14);
  let T0;
  let T1;
  let T2;
  let T3;
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const pieData = mockCostBreakdown.providers.map(_temp);
    t4 = "space-y-6";
    t5 = <div className="grid gap-4 md:grid-cols-3"><MetricCard label="Total Spend" value={`$${mockCostBreakdown.total.toFixed(2)}`} subtitle="Last 7 days" icon={<DollarSign className="h-4 w-4" />} accent="green" /><MetricCard label="Avg Cost per 1K Tokens" value="$0.106" subtitle="Blended rate" icon={<Coins className="h-4 w-4" />} accent="blue" /><MetricCard label="Total Tokens" value={mockMetrics.totalTokens} subtitle="Input + Output" icon={<TrendingUp className="h-4 w-4" />} accent="purple" /></div>;
    t3 = "grid gap-6 md:grid-cols-2";
    T3 = Card;
    t2 = <CardHeader><CardTitle>Cost by Provider</CardTitle><CardDescription>Distribution of spending across providers</CardDescription></CardHeader>;
    T2 = CardContent;
    T1 = ResponsiveContainer;
    t0 = "100%";
    t1 = 300;
    T0 = PieChart;
    t6 = <Pie data={pieData} cx="50%" cy="50%" labelLine={false} label={_temp2} outerRadius={80} fill="#8884d8" dataKey="value">{pieData.map(_temp3)}</Pie>;
    $[0] = T0;
    $[1] = T1;
    $[2] = T2;
    $[3] = T3;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    T0 = $[0];
    T1 = $[1];
    T2 = $[2];
    T3 = $[3];
    t0 = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <T3>{t2}<T2><T1 width={t0} height={t1}><T0>{t6}<Tooltip content={<PieTooltipContent payload={[]} />} /></T0></T1></T2></T3>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <CardHeader><CardTitle>Provider Breakdown</CardTitle><CardDescription>Detailed cost analysis by provider</CardDescription></CardHeader>;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className={t4}>{t5}<div className={t3}>{t7}<Card>{t8}<CardContent><div className="space-y-3">{mockCostBreakdown.providers.map(_temp4)}</div></CardContent></Card></div></div>;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
}
function _temp4(provider, index_0) {
  return <div key={provider.name} className="flex items-center justify-between p-3 rounded-lg border"><div className="flex items-center gap-3"><div className="h-3 w-3 rounded-full" style={{
        backgroundColor: COLORS[index_0 % COLORS.length]
      }} /><div><p className="font-medium">{provider.name}</p><p className="text-sm text-muted-foreground">{provider.percentage.toFixed(1)}% of total</p></div></div><div className="text-right"><p className="font-semibold">${provider.cost.toFixed(2)}</p></div></div>;
}
function _temp3(entry, index) {
  return <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />;
}
function _temp2(props) {
  const {
    name,
    percent
  } = props;
  return `${name} ${((percent as number) * 100).toFixed(0)}%`;
}
function _temp(p) {
  return {
    name: p.name,
    value: p.cost
  };
}